import { PipeColumn } from '@formo/types';

export const PIPES_COLUMNS: PipeColumn[] = [
  {
    name: 'anonymous_users',
    columns: [
      'project_id',
      'anonymous_id',
      'first_seen',
      'last_seen',
      'first_utm_source',
      'last_utm_source',
      'first_utm_medium',
      'last_utm_medium',
      'first_utm_campaign',
      'last_utm_campaign',
      'first_utm_content',
      'last_utm_content',
      'first_utm_term',
      'last_utm_term',
      'first_referrer',
      'last_referrer',
      'first_ref',
      'last_ref',
      'num_sessions',
      'revenue',
      'points',
      'last_type',
      'last_properties',
      'location',
      'device',
      'browser',
      'os',
    ],
  },
  {
    name: 'dedup_parsed_events',
    columns: [
      'project_id',
      'session_id',
      'channel',
      'type',
      'anonymous_id',
      'user_id',
      'address',
      'event',
      'context',
      'properties',
      'version',
      'timestamp',
      'message_id',
      'origin',
      'locale',
      'location',
      'timezone',
      'page_path',
      'page_title',
      'page_url',
      'library_name',
      'library_version',
      'referrer',
      'ref',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'user_agent',
      'device',
      'browser',
      'os',
    ],
  },
  {
    name: 'pages',
    columns: [
      'project_id',
      'date',
      'origin',
      'pathname',
      'device',
      'browser',
      'os',
      'location',
      'referrer',
      'ref',
      'utm_medium',
      'utm_source',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'visits',
      'hits',
    ],
  },
  {
    name: 'revenue',
    columns: [
      'project_id',
      'origin',
      'pathname',
      'date',
      'device',
      'browser',
      'os',
      'location',
      'referrer',
      'ref',
      'utm_medium',
      'utm_source',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'rdns',
      'provider_name',
      'chain_id',
      'revenue',
      'points',
    ],
  },
  {
    name: 'anonymous_user_id',
    columns: ['project_id', 'session_id', 'anonymous_id', 'address', 'user_id'],
  },
  {
    name: 'sessions',
    columns: [
      'project_id',
      'origin',
      'session_id',
      'date',
      'device',
      'browser',
      'os',
      'location',
      'referrer',
      'ref',
      'utm_medium',
      'utm_source',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'first_hit',
      'latest_hit',
      'hits',
    ],
  },
  {
    name: 'sources',
    columns: [
      'project_id',
      'date',
      'origin',
      'referrer',
      'device',
      'browser',
      'os',
      'location',
      'ref',
      'utm_medium',
      'utm_source',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'visits',
      'hits',
    ],
  },
  {
    name: 'chains',
    columns: [
      'project_id',
      'chain_id',
      'date',
      'origin',
      'device',
      'browser',
      'os',
      'location',
      'referrer',
      'ref',
      'utm_medium',
      'utm_source',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'visits',
    ],
  },
  {
    name: 'users',
    columns: [
      'project_id',
      'address',
      'first_seen',
      'last_seen',
      'first_utm_source',
      'last_utm_source',
      'first_utm_medium',
      'last_utm_medium',
      'first_utm_campaign',
      'last_utm_campaign',
      'first_utm_content',
      'last_utm_content',
      'first_utm_term',
      'last_utm_term',
      'first_referrer',
      'last_referrer',
      'first_ref',
      'last_ref',
      'num_sessions',
      'revenue',
      'points',
      'last_type',
      'last_properties',
      'location',
      'device',
      'browser',
      'os',
    ],
  },
  {
    name: 'wallet_types',
    columns: [
      'project_id',
      'date',
      'origin',
      'rdns',
      'providerName',
      'device',
      'browser',
      'os',
      'location',
      'referrer',
      'ref',
      'utm_medium',
      'utm_source',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'visits',
    ],
  },
  {
    name: 'project_anonymous_users_count',
    columns: ['project_id', 'total'],
  },
  {
    name: 'transactions',
    columns: ['date', 'project_id', 'total_transactions'],
  },
  {
    name: 'project_users_count',
    columns: ['project_id', 'total'],
  },
  {
    name: 'revenue_overview',
    columns: ['date', 'project_id', 'revenue'],
  },
  {
    name: 'current_users_count',
    columns: ['project_id', 'visits'],
  },
  {
    name: 'top_sources_metrics',
    columns: ['project_id', 'referrer', 'visits', 'hits'],
  },
  {
    name: 'top_wallet_types',
    columns: ['project_id', 'rdns', 'visits'],
  },
  {
    name: 'kpis',
    columns: [
      'date',
      'project_id',
      'visitors',
      'pageviews',
      'bounce_rate',
      'avg_session_sec',
    ],
  },
  {
    name: 'revenue_by_metrics',
    columns: ['project_id', 'pathname', 'sum_revenue'],
  },
  {
    name: 'top_pages',
    columns: ['project_id', 'origin', 'pathname', 'visits', 'hits'],
  },
  {
    name: 'linked_addresses',
    columns: [],
  },
  {
    name: 'wallets',
    columns: ['date', 'project_id', 'wallets'],
  },
  {
    name: 'latest_address_session',
    columns: [],
  },
  {
    name: 'project_events_count',
    columns: ['project_id', 'total'],
  },
  {
    name: 'top_chains',
    columns: ['project_id', 'chain_id', 'visits'],
  },
  {
    name: 'project_events',
    columns: [
      'message_id',
      'project_id',
      'anonymous_id',
      'user_id',
      'session_id',
      'timestamp',
      'type',
      'event',
      'address',
      'origin',
      'version',
      'locale',
      'location',
      'timezone',
      'referrer',
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'ref',
      'user_agent',
      'device',
      'browser',
      'os',
      'context',
      'properties',
    ],
  },
  {
    name: 'wallet_events',
    columns: [],
  },
  {
    name: 'project_anonymous_users',
    columns: [
      'project_id',
      'anonymous_id',
      'first_seen',
      'last_seen',
      'first_referrer',
      'first_utm_source',
      'first_utm_medium',
      'first_utm_campaign',
      'first_utm_term',
      'first_utm_content',
      'first_ref',
      'location',
      'device',
      'browser',
      'os',
      'num_sessions',
      'last_type',
      'last_properties',
    ],
  },
  {
    name: 'top_locations',
    columns: ['project_id', 'location', 'visits', 'hits'],
  },
  {
    name: 'distinct_values',
    columns: ['address', 'project_id'],
  },
  {
    name: 'project_users',
    columns: [
      'project_id',
      'address',
      'first_seen',
      'last_seen',
      'first_referrer',
      'first_utm_source',
      'first_utm_medium',
      'first_utm_campaign',
      'first_utm_term',
      'first_utm_content',
      'first_ref',
      'location',
      'device',
      'browser',
      'os',
      'num_sessions',
      'last_type',
      'last_properties',
    ],
  },
  {
    name: 'wallet_events_count',
    columns: [],
  },
  {
    name: 'monitoring_errors_last_hour',
    columns: ['pipe_name', 'status_code', 'error_count'],
  },
  {
    name: 'monitoring_quarantine_last_hour',
    columns: ['not_ok', 'ok', 'percentage_failed', 'quarantined_rows'],
  },
];
